import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CuotasService {

  url = environment.baseURL + 'mercadopago';


  constructor(private http: HttpClient) { }

  getOfertasTarjetas(): Observable<any[]> {
    //const header = new Headers({ 'Authorization': `Bearer TEST-3573383013844763-011811-90ff76a02c0accb4f985532746c07372-468684645` });
    const url = this.url;
    //return this.http.get<any[]>(url,{headers: {'Authorization':'Bearer TEST-3573383013844763-011811-90ff76a02c0accb4f985532746c07372-468684645'}});
    return this.http.get<any[]>(url);

  }
}
